import { createApp } from 'vue';
import App from '@/App.vue';
import store from '@/store';
import router from '@/router';
import { apiRegisterInterceptors } from '@/plugins/api.js';
import useAppSetupHook from '@/hooks/useAppSetup.js';

apiRegisterInterceptors();

const app = createApp(App);

app.use(store);

const {
  initialDataFetch,
  registerGlobalProperties,
  initializeGtm,
} = useAppSetupHook(app);

initialDataFetch().then(() => {
  registerGlobalProperties();

  const gtm = initializeGtm(router);

  if (gtm) {
    app.use(gtm);
  }

  app.use(router);

  app.mount('#app');
});
